"use strict";

function Ajaxinate(options) {
  this.settings = Object.assign(
    {
      pagination: "#AjaxinatePagination",
      method: "scroll",
      container: "#AjaxinateLoop",
      offset: 0,
      loadingText: "Loading",
      callback: null,
      preload: false,
      estimatedCardHeight: 400,
      estimatedCardCount: 16,
    },
    options || {}
  );

  this._preloadedPageContent = null;
  this._preloadXHR = null;

  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.removeScrollListener = this.removeScrollListener.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.destroy = this.destroy.bind(this);

  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);

  this.initialize();
}

Ajaxinate.prototype.initialize = function () {
  if (!this.containerElement || !this.paginationElement) return;

  if (this.settings.method === "click") {
    this.addClickListener();
  } else {
    this.addScrollListeners();
  }

  if (this.settings.preload) {
    const nextPageLink = this.paginationElement.querySelector("a");
    if (nextPageLink && nextPageLink.href) {
      this._preloadNextPage(nextPageLink.href);
    }
  }
};

Ajaxinate.prototype.addScrollListeners = function () {
  this.scrollListener = this.checkIfPaginationInView;
  document.addEventListener("scroll", this.scrollListener);
  window.addEventListener("resize", this.scrollListener);
  window.addEventListener("orientationchange", this.scrollListener);
};

Ajaxinate.prototype.removeScrollListener = function () {
  document.removeEventListener("scroll", this.scrollListener);
  window.removeEventListener("resize", this.scrollListener);
  window.removeEventListener("orientationchange", this.scrollListener);
};

Ajaxinate.prototype.checkIfPaginationInView = function () {
  if (!this.paginationElement) return;

  const rect = this.paginationElement.getBoundingClientRect();
  const offset = this.settings.offset;

  if (rect.top - offset <= window.innerHeight && rect.bottom + offset >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    if (this.nextPageLinkElement) {
      this.removeScrollListener();
      this.nextPageLinkElement.innerHTML = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.addClickListener = function () {
  if (!this.paginationElement) return;

  this.nextPageLinkElement = this.paginationElement.querySelector("a");
  if (this.nextPageLinkElement) {
    this.clickActive = true;
    this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
  }
};

Ajaxinate.prototype.stopMultipleClicks = function (e) {
  e.preventDefault();
  if (!this.clickActive) return;

  this.nextPageLinkElement.innerHTML = this.settings.loadingText;
  this.nextPageUrl = this.nextPageLinkElement.href;
  this.clickActive = false;
  this.loadMore();
};

Ajaxinate.prototype._preloadNextPage = function (url) {
  if (!url) return;

  if (this._preloadXHR) {
    this._preloadXHR.abort();
  }

  this._preloadXHR = new XMLHttpRequest();
  this._preloadXHR.open("GET", url);
  this._preloadXHR.responseType = "document";

  this._preloadXHR.onreadystatechange = function () {
    if (this._preloadXHR.readyState === 4 && this._preloadXHR.status === 200) {
      const container = this._preloadXHR.responseXML.querySelector(this.settings.container);
      const pagination = this._preloadXHR.responseXML.querySelector(this.settings.pagination);

      if (container) {
        this._preloadedPageContent = {
          container: container,
          pagination: pagination,
          responseXML: this._preloadXHR.responseXML,
        };
      }
    }
  }.bind(this);

  this._preloadXHR.send();
};

Ajaxinate.prototype.loadMore = function () {
  const placeholder = document.createElement("div");
  placeholder.className = "ajaxinate-placeholder";
  placeholder.style.height = `${this.settings.estimatedCardHeight * this.settings.estimatedCardCount}px`;
  this.containerElement.appendChild(placeholder);

  for (let i = 0; i < this.settings.estimatedCardCount; i++) {
    const skeleton = document.createElement("div");
    skeleton.innerHTML = `
      <div class="product-card skeleton">
        <div class="skeleton-image"></div>
        <div class="skeleton-text-line short"></div>
        <div class="skeleton-text-line long"></div>
      </div>
    `;
    this.containerElement.appendChild(skeleton.firstChild);
  }

  const finishLoad = (newContent, newPagination, responseXML) => {
    placeholder.remove();
    document.querySelectorAll('.skeleton').forEach(el => el.remove());

    const chunk = document.createElement("div");
    chunk.className = "ajaxinate-chunk";
    chunk.innerHTML = newContent.innerHTML;
    this.containerElement.appendChild(chunk);

    if (!newPagination) {
      this.removePaginationElement();
    } else {
      this.paginationElement.innerHTML = newPagination.innerHTML;
    }

    if (this.settings.callback && typeof this.settings.callback === "function") {
      this.settings.callback(responseXML);
    }

    this.initialize();
  };

  if (this._preloadedPageContent) {
    const { container, pagination, responseXML } = this._preloadedPageContent;
    this._preloadedPageContent = null;
    finishLoad(container, pagination, responseXML);
  } else {
    this.request = new XMLHttpRequest();
    this.request.onreadystatechange = function () {
      if (this.request.readyState === 4 && this.request.status === 200 && this.request.responseXML) {
        const container = this.request.responseXML.querySelector(this.settings.container);
        const pagination = this.request.responseXML.querySelector(this.settings.pagination);
        finishLoad(container, pagination, this.request.responseXML);
      }
    }.bind(this);

    this.request.open("GET", this.nextPageUrl);
    this.request.responseType = "document";
    this.request.send();
  }
};

Ajaxinate.prototype.removeClickListener = function () {
  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.removeEventListener("click", this.stopMultipleClicks);
  }
};

Ajaxinate.prototype.removePaginationElement = function () {
  this.paginationElement.innerHTML = "";
  this.destroy();
};

Ajaxinate.prototype.destroy = function () {
  if (this.settings.method === "click") {
    this.removeClickListener();
  } else {
    this.removeScrollListener();
  }
  return this;
};
